import { useMutation } from "@apollo/client"
import CustomButton from "components/Atoms/CustomButton"
import CustomDateInput from "components/Atoms/CustomDateInput"
import CustomFormGroup from "components/Atoms/CustomFormGroup"
import CustomRadio from "components/Atoms/CustomRadio"
import CustomRadioGroup from "components/Atoms/CustomRadioGroup"
import StringInput from "components/Atoms/StringInput"
import DynamicSelector from "components/Molecules/DynamicSelector"
import FileUploadDialog from "components/Templates/FileUploadDialog"
import { DELETE_DC_CERTIFICATION } from "graphql/distribution-center/distribution-center.mutations.gql"
import { CERTIFICATES } from "graphql/selector.queries.gql"
import React, { useState } from "react"
import useDCStore from "../dc.store"
import FormCard from "../FormCard"
import useDCRemoveM2M from "../useDCRemoveM2M"

type LicenceDetailProps = {
  data?: any
  index: number
}
const LicenceDetail = ({ data, index }: LicenceDetailProps) => {
  const [removeListItem, disabled] = useDCStore(store => [
    store.removeListItem,
    store.disabled,
  ])
  const method = data?.paymentMethod?.id
  const [isFileUploadOpen, setUpload] = useState(false)
  const [mutate] = useMutation(DELETE_DC_CERTIFICATION)
  const { removeLink } = useDCRemoveM2M()
  return (
    <FormCard
      onRemove={() => {
        if (data?.id) {
          mutate({
            variables: { ids: [data?.id] },
            onCompleted: () => removeListItem("licenseDetails", index, true),
          })
        } else {
          removeListItem("licenseDetails", index)
        }
      }}
      title={data?.idNumber || method || `Licence ${index + 1}`}
    >
      <DynamicSelector
        query={CERTIFICATES}
        path={`${index}.certificationType`}
        big={false}
        required
        label="Licence Name"
      />
      <StringInput
        path={`${index}.idNumber`}
        big={false}
        required
        label="Licence Number"
      />
      <CustomFormGroup required label="Attachments">
        <CustomButton
          className="self-center w-full"
          disabled={disabled}
          icon="cloud-upload"
          text="Upload Files"
          onClick={e => setUpload(true)}
        />
      </CustomFormGroup>

      <FileUploadDialog
        btnClassName="self-end"
        path={`${index}.attachments`}
        isOpen={isFileUploadOpen}
        onClose={() => setUpload(false)}
        onDelete={photo => {
          if (!data?.id && photo?.id) return
          removeLink({
            fieldName: "attachments",
            fieldIds: [photo?.id],
            modelId: data?.id,
            displayName: "Licence Attachment",
            modelName: "vt_core.Certification",
          })
        }}
      />
      <CustomDateInput
        path={`${index}.validFrom`}
        big={false}
        required
        label="Issue Date"
      />
      <CustomFormGroup
        className="vt-horizontal-radio-group"
        label="License has a validity"
      >
        <CustomRadioGroup path={`${index}.hasValidity`}>
          <CustomRadio name="Yes" id="yes" />
          <CustomRadio name="No" id="no" />
        </CustomRadioGroup>
      </CustomFormGroup>
      {data?.hasValidity === "yes" && (
        <CustomDateInput
          path={`${index}.validTill`}
          big={false}
          label="Valid Till"
        />
      )}
    </FormCard>
  )
}

export default LicenceDetail
